export const SE_MY_SPORTSENGINE_NAV_TREE = {
  label: 'SeMySportsengine', secondaryItems: [
    {
      label: 'SeMySportsengine',
      key: 'se-my-sportsengine',
      attributes: { href: '/docs/se-my-sportsengine/overview' }
    },
    {
      label: 'Feature Child Grant Access Modal',
      key: 'se-my-sportsengine-feature-child-grant-access-modal',
      attributes: { href: '/docs/se-my-sportsengine/feature-child-grant-access-modal' }
    },
    {
      label: 'Feature Credential Table',
      key: 'se-my-sportsengine-feature-credential-table',
      attributes: { href: '/docs/se-my-sportsengine/feature-credential-table' }
    },
    {
      label: 'Feature Guardian Access',
      key: 'se-my-sportsengine-feature-guardian-access',
      attributes: { href: '/docs/se-my-sportsengine/feature-guardian-access' }
    },
    {
      label: 'Feature Household',
      key: 'se-my-sportsengine-feature-household',
      attributes: { href: '/docs/se-my-sportsengine/feature-household' }
    },
    {
      label: 'Feature Household Contact Card',
      key: 'se-my-sportsengine-feature-household-contact-card',
      attributes: { href: '/docs/se-my-sportsengine/feature-household-contact-card' }
    },
    {
      label: 'Feature Household Side Panel',
      key: 'se-my-sportsengine-feature-household-side-panel',
      attributes: { href: '/docs/se-my-sportsengine/feature-household-side-panel' }
    },
    {
      label: 'Feature Membership Table',
      key: 'se-my-sportsengine-feature-membership-table',
      attributes: { href: '/docs/se-my-sportsengine/feature-membership-table' }
    },
    {
      label: 'Feature MFA Methods Card',
      key: 'se-my-sportsengine-feature-mfa-methods-card',
      attributes: { href: '/docs/se-my-sportsengine/feature-mfa-methods-card' }
    },
    {
      label: 'Feature New Guardian Modal',
      key: 'se-my-sportsengine-feature-new-guardian-modal',
      attributes: { href: '/docs/se-my-sportsengine/feature-new-guardian-modal' }
    },
    {
      label: 'Feature New Person Modal',
      key: 'se-my-sportsengine-feature-new-person-modal',
      attributes: { href: '/docs/se-my-sportsengine/feature-new-person-modal' }
    },
    {
      label: 'Feature Organizations Page',
      key: 'se-my-sportsengine-feature-organizations-page',
      attributes: { href: '/docs/se-my-sportsengine/feature-organizations-page' }
    },
    {
      label: 'Feature Parent Grant Access Modal',
      key: 'se-my-sportsengine-feature-parent-grant-access-modal',
      attributes: { href: '/docs/se-my-sportsengine/feature-parent-grant-access-modal' }
    },
    {
      label: 'Feature Permissions Card',
      key: 'se-my-sportsengine-feature-permissions-card',
      attributes: { href: '/docs/se-my-sportsengine/feature-permissions-card' }
    },
    {
      label: 'UI Household Avatar',
      key: 'se-my-sportsengine-ui-household-avatar',
      attributes: { href: '/docs/se-my-sportsengine/ui-household-avatar' }
    },
    {
      label: 'UI Organization Card',
      key: 'se-my-sportsengine-ui-organization-card',
      attributes: { href: '/docs/se-my-sportsengine/ui-organization-card' }
    },
    {
      label: 'UI Persona Eligibility Side Panel',
      key: 'se-my-sportsengine-ui-persona-eligibility-side-panel',
      attributes: { href: '/docs/se-my-sportsengine/ui-persona-eligibility-side-panel' }
    },
    {
      label: 'UI USAV Launch',
      key: 'se-my-sportsengine-ui-usav-launch',
      attributes: { href: '/docs/se-my-sportsengine/ui-usav-launch' }
    }
  ]
}
